$(document).on('ready', function () {
    var $body = $('body');
    window.productsData = [];
    var pageSize = 24;
    window.currentPage = 1;
    var filterBarsElement = $('.filter-items');
    window.availableFilterAttributes = filterBarsElement.data('filters').split(',');

    if (!window.usingAjax) {
        var products = [];
        var productsDataElement = $("#productsData");
        var productsElement = productsDataElement.find('product');

        if (productsElement.length > 0) {
            $.each(productsElement, function (index, productElement) {
                var product = $(productElement);
                products.push({
                    'title': product.data('title'),
                    'price': product.data('price'),
                    'formattedPrice': product.data('formatted_price'),
                    'compareAtPrice': product.data('compare_at_price'),
                    'collection': product.data('collection'),
                    'image1': product.data('image'),
                    'image2': product.data('image2'),
                    'url': product.data('url'),
                    'available': product.data('available'),
                    'tags': product.data('tags').split('|')
                });
            });
        }
        window.productsData = products;
    } else {
        $(document).on("product-refreshed", function (event) {
            renderFilters();
            renderPriceRange();
            refresh();
        });
    }

    if (!window.usingAjax) {
        renderFilters();
    }


    // The price filter
    var priceFilterElement = $(".priceRange");
    if (!window.usingAjax) {
        renderPriceRange();
    }

    priceFilterElement.on('change', function (e) {
        window.currentPage = 1;
        var newPrice = $(e.currentTarget).val();
        priceFilterElement.val(newPrice);
        refreshUrl(buildParams('page', 1));
        refresh($(this).val());
    });

    $body.on('click', '#live-pagination .page', function () {
        var currentPage = parseInt($(this).data('page'));
        if (currentPage > 0 && currentPage !== window.currentPage) {
            window.currentPage = currentPage;
            $body.trigger('page_change');
            refresh();
        }
    });

    $body.on('click', '#live-pagination .next', function () {
        window.currentPage++;
        $body.trigger('page_change');
        refresh();
    });

    $body.on('page_change', function () {
        refreshUrl(buildParams('page', window.currentPage));
    });

    $body.on('click', '.auto-click-js', function (e) {
        if ($(e.currentTarget).parent().hasClass('active')) {
            $(this).parent().removeClass("active");
        } else {
            $(".collection-categories-section .filter-item").removeClass('active');
            $(this).parent().addClass("active");
        }

    });

    $body.on('click', '.count-filter', function (e) {
        $(e.currentTarget).parents("filter-item").removeClass('active');
    });

    $body.on('change', '[name="filter_tags[]"]', function () {
        window.currentPage = 1;
        refreshUrl(buildParams('page', 1));
        refresh();
    });

    $body.on('click', '.reset-filter-button', function (e) {
        $(".filter-items").find('.filter-item').find(".clear-selections").trigger("click");
    });

    $body.on("change", ".filter-collection", function () {
        countChecked();
    });

    $body.on("click", ".clear-selections", function (event) {
        $(this).parent().find("input").prop('checked', false);
        countChecked();
        refresh();
        $(event.currentTarget).parents(".filter-item").removeClass("active");
    });

    $body.on("click", ".clear-all-selections", function () {
        $(".filter-items input").prop('checked', false);
        countChecked();
        refresh();
    });

    /**
     * Get checked tags (selected attributes in filters navigation)
     *
     * @returns {this} an array of attribute codes
     */
    function getCheckedTags() {
        var checkedTags = $body.find('[name="filter_tags[]"]:checked');
        var tags = [];
        if (checkedTags.length > 0) {
            $.each(checkedTags, function (index, element) {
                if (!tags.includes($(element).val())) {
                    tags.push($(element).val());
                }
            })
        }
        return tags.sort();
    }

    function refresh() {
        var $newData = getNewData();
        $('.product-list').html(renderGrid($newData) + renderPagination($newData));
        $('.product-content').show();
        $('#pageSize').html();
        $('#totalProducts').html();
        //$(window).scrollTop(0);
    }

    function refreshUrl(params) {
        history.pushState(null, null, location.protocol + '//' + location.host + location.pathname + params);
    }

    if (getUrlParam('page')) {
        window.currentPage = parseInt(getUrlParam('page'));
    }

    function buildParams(key, value) {
        var currentParams = getUrlParam();
        currentParams[key] = value;
        return "?" + $.param(currentParams);
    }

    function renderPagination($data) {
        var numberOfPages = Math.ceil($data.length / pageSize);
        var output = "";
        if (numberOfPages <= 1) {
            return output;
        }
        output += `<div id="live-pagination" class="pagination ec-pagination">`;
        for (var i = 1; i <= numberOfPages; i++) {
            output += `<span class="page ${getCurrentPage(numberOfPages) === i ? 'current' : ''}" data-page="${i}">${i}</span>`;
        }
        if (getCurrentPage() < numberOfPages) {
            output += `
                <span class=" page next">
                  <i class="fal fa-angle-right"></i>
                </span>
            `;
        }
        output += `</div>`;
        return output;
    }

    /***
     * Get products collection base on the selected filters
     *
     * 1. and for multi filters
     * 2. or when customer selects multi attributes in a filter
     *
     * @returns {Array}
     */
    function getNewData() {
        var $newData = [];
        //Filter products with or-condition
        if (window.productsData && window.productsData.length > 0) {
            $.each(window.productsData, function (index, $product) {
                if (parseFloat($product.price) <= window.toPrice && parseFloat($product.price) >= window.fromPrice) {
                    var checkedTags = getCheckedTags();
                    if (checkedTags.length > 0) {
                        for (var i = 0; i < checkedTags.length; i++) {
                            if ($product.tags.includes(checkedTags[i])) {
                                $newData.push($product);
                            }
                        }
                    } else {
                        $newData.push($product);
                    }
                }
            });
        }

        //Filter products
        var checkedTags = getCheckedTags();
        if (checkedTags.length == 0) {
            return $newData;
        }
        var $filterData = [];
        var $prefix = [];
        for (var i = 0; i < checkedTags.length; i++) {
            var type = checkedTags[i].split("-");
            $prefix.push(type[0]);
        }
        for (var p = 0; p < $newData.length; p++) {
            var $currentProduct = $newData[p];
            //Update logic for and-condition
            var $match = true;
            for (var i = 0; i < $prefix.length; i++) {
                var $flag = false;
                for (var k = 0; k < checkedTags.length; k++) {
                    var type = checkedTags[k].split("-");
                    if (type[0] != $prefix[i]) continue;
                    if ($currentProduct.tags.includes(checkedTags[k])) {
                        $flag = true;
                        break;
                    }
                }
                //At least one item in group is matched
                if (!$flag) {
                    $match = $flag;
                    break;
                }
            }

            //Remove duplicate in the result
            if ($match) {
                var flag = true;
                for (var j = 0; j < $filterData.length; j++) {
                    var productUrl = $filterData[j].url;
                    if (productUrl == $currentProduct.url) {
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    $filterData.push($currentProduct);
                }
            }
        }
        return $filterData;
    }

    /**
     * Get params from url
     *
     * @param $key
     * @returns {*}
     */
    function getUrlParam($key = null) {
        var params = {};
        var parser = document.createElement('a');
        parser.href = window.location.href;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair.length === 2) {
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
        }
        if ($key === null) {
            return params;
        }
        return params[$key];
    }

    /**
     * Generate product template
     *
     * @param $product
     * @returns {string}
     */
    function productTemplate($product) {
        var tags = $product.tags;
        var tags_div = '';
        if (tags.length > 0) {
            tags.forEach(function (item, index) {
                if (item.indexOf('banner-') >= 0) {
                    var item_txt = item.replace("-", " ").replace("banner-", "");
                    tags_div = '<div class="promo-tag"><p class="tag">' + item_txt + '</p></div>';
                }
            });
        }

        return `
                    <div class="col-lg-3 col-md-4 col-sm-6 col-6 product-list-item">
                        <div class="item-content">
                            <div class="product-image-block">
                                <a href="` + $product.url + `" class="grid__image  collection_img_item"  aria-haspopup="true">
                                    <div class="mouse-out">
                                        <img src="` + $product.image1 + `" alt="` + $product.title + `">
                                    </div>
                                    <div class="mouse-over">
                                        <img src="` + $product.image2 + `">
                                    </div>
                                </a>
                                ` + tags_div + `
                            </div>

                            <div class="product-item-info-wrapper">
                                <div class="product-list-title">` + $product.collection + `</div>
                                <div class="shop-product-title">
                                    <a href="` + $product.url + `">` + $product.title + `</a>
                                </div>
                                <div class="product-list-price price-block">
                                        ${($product.compareAtPrice) ? "<span class='old-price'>" + ($product.compareAtPrice / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        }) + "</span>" : ""}
                                        <span class="${($product.compareAtPrice) ? "special-price" : "shop-product-price"}">` + $product.formattedPrice + `</span>
                                        ${($product.available === true) ? "" : "<br /> <strong>Out Of Stock</strong>"}
                                </div>

                                <form class="product-form" action="/cart/add" enctype="multipart/form-data" id="AddToCartForm">
                                    <input type="hidden" name="id" value="` + $product.id + `">
                                    <input type="hidden" name="quantity" id="quantity" value="1">
                                    <div class="add-to-cart text-center">

                                            <div class="product-form-submit-wrap">
                                                <button class="btn btn-cart-shop btn-addcart-ajax" type="submit">
                                                    ADD TO BAG
                                                </button>
                                                <div class="add-to-cart-loader"></div>
                                            </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                `;
    }

    /**
     * Render grid result
     *
     * @param $products
     * @returns {string}
     */
    function renderGrid($products) {
        var $output = "";
        if (typeof pageSize == "undefined") {
            pageSize = 16;
        }
        var offset = (getCurrentPage() - 1) * pageSize;
        var items = $products.slice(offset, pageSize + offset);
        //Next page
        var number_to = pageSize + offset;
        // Last page is not full of items
        if(number_to > $products.length){
            number_to = $products.length;
        }
        var total_from = (number_to) ? offset + 1 : 0;

        $(".pageSize").html(total_from + '-' + parseInt(number_to));
        $(".totalProducts").html($products.length);

        $.each(items, function (index, $products) {
            $output += productTemplate($products);
        });
        return $output;
    }

    function getCurrentPage(numberOfPages = false) {
        var page;
        if (window.currentPage || getUrlParam('page')) {
            page = parseInt(getUrlParam('page') ? getUrlParam('page') : window.currentPage);
        } else {
            page = 1;
        }
        if (numberOfPages && page > numberOfPages) {
            return numberOfPages;
        }
        return page;
    }

    function getMinPrice() {
        var minPrice;
        $.each(window.productsData, function (index, product) {
            if (index === 0) {
                minPrice = parseFloat(product.price);
            } else {
                if (product.price < minPrice) {
                    minPrice = parseFloat(product.price)
                }
            }
        });
        return minPrice;
    }

    function getMaxPrice() {
        var maxPrice;
        $.each(window.productsData, function (index, product) {
            if (index === 0) {
                maxPrice = parseFloat(product.price);
            } else {
                if (product.price > maxPrice) {
                    maxPrice = parseFloat(product.price);
                }
            }
        });
        return maxPrice;
    }

    /**
     * Get filter items
     */
    function getFilterItems() {
        var filterItems = {};

        if (window.availableFilterAttributes.length > 0) {
            $.each(window.productsData, function (index, product) {
                if (product.tags) {
                    $.each(product.tags, function (index, tag) {
                        $.each(window.availableFilterAttributes, function (index, aTag) {
                            if (tag.indexOf(aTag + '-') === 0) {
                                if (!filterItems[aTag]) {
                                    filterItems[aTag] = [];
                                }
                                if (!filterItems[aTag].includes(tag.replace(aTag + '-', ''))) {
                                    filterItems[aTag].push(tag.replace(aTag + '-', ''));
                                    filterItems[aTag].sort();
                                }
                            }
                        });
                    });
                }
            });
        }
        if (filterItems['size']) {
            filterItems['size'] = filterItems['size'].sort(function (a, b) {
                return extractSize(a) < extractSize(b) ? -1 : (extractSize(a) === extractSize(b)) ? 0 : 1;
            })
        }
        return filterItems;
    }

    function extractSize(sizeValue) {
        var value = sizeValue.split(' ');
        var size = value[0];
        return parseInt(size.replace('oz', ''));
    }

    function renderFilters() {

        var filters = getFilterItems();
        var filterHtml = "";

        $.each(window.availableFilterAttributes, function (index, aTag) {
            if (filters[aTag]) {
                filterHtml += renderFilterItem(aTag, filters[aTag])
            }
        });
        $(filterHtml).insertBefore($('.slidecontainer'));
    }

    function renderFilterItem(key, values) {
        var filterTemplate = `
            <li class="filter-item ` + key + `-filter">
                <p class="label size auto-click-js">` + key + `<span class="count-filter"></span></p>
                <div class="item-collection">
                    <ul class="filter-collection">
                      `;
        $.each(values, function (index, tagValue) {
            filterTemplate += `
                    <li>
                        <p class="form-check">
                            <label class="form-check-label" for="` + key + '-' + tagValue + `" style="position: relative;">
                                <input type="checkbox" name="filter_tags[]" class="form-check-input" id="` + key + '-' + tagValue + `" value="` + key + '-' + tagValue + `"><span class="comment_wrapper after_checkbox"></span>
                                <span class="text-reme" for="` + key + '-' + tagValue + `">` + tagValue.replace(/-/g, ' ') + `</span>
                            </label>
                        </p>
                    </li>
                `;
        });
        filterTemplate += `
            </ul>
            <a class="clear-selections">Clear Selections</a>
                </div>
            </li>
        `;
        return filterTemplate;
    }

    /**
     * Count and update total number of checked items on a filter section
     */
    function countChecked() {
        var totalCheckedItems = 0;
        var currentFilterItems = $(".filter-item");
        $.each(currentFilterItems, function (index, item) {
            var filterItem = $(item);
            var checkedItems = filterItem.find(".filter-collection").find("input:checked").length;
            totalCheckedItems += checkedItems;
            if (checkedItems > 0) {
                filterItem.find(".clear-selections").show();
                filterItem.find(".count-filter").html(checkedItems).addClass("active");
            } else {
                filterItem.find(".count-filter").html("").removeClass("active");
                filterItem.find(".clear-selections").hide();
            }
        });
        if (totalCheckedItems) {
            $(".a-right .clear-all-selections").addClass("activess");
        } else {
            $(".a-right .clear-all-selections").removeClass("activess");
        }
    }

    function renderPriceRange() {
        $( ".price-range" ).each(function (i, e) {
            var elem = $(e);
            elem.slider({
                range: true,
                min: getMinPrice(),
                max: getMaxPrice(),
                values: [ getMinPrice(), getMaxPrice() ],
                change: function( event, ui ) {
                    $( ".minPrice" ).text( "$" + ui.values[ 0 ] );
                    $( ".maxPrice" ).text( "$" + ui.values[ 1 ] );
                    if (window.shouldRefreshUrl) {
                        refreshUrl(buildParams('price', ui.values[ 0 ] + "-" + ui.values[ 1 ]));
                    }
                    window.fromPrice = ui.values[0];
                    window.toPrice = ui.values[1];
                    refresh();
                    window.shouldRefreshUrl = true;
                },
                create: function( event, ui ) {
                    if (getUrlParam('price')) {
                        var prices = getUrlParam('price').split("-");
                        if ( prices.length === 1 ) {
                            var currentPrice = prices[0];
                            prices[0] = getMinPrice();
                            prices[1] = currentPrice;
                        }
                        window.shouldRefreshUrl = true;
                        elem.slider("values", prices[0], prices[1]);
                        $( ".minPrice" ).text( "$" + (prices[0]) );
                        $( ".maxPrice" ).text( "$" + (prices[1]) );
                        window.fromPrice = prices[0];
                        window.toPrice = prices[1];
                        refresh();
                    } else {
                        window.shouldRefreshUrl = false;
                        elem.slider("values", getMaxPrice(), getMaxPrice());
                        $( ".minPrice" ).text( "$" + getMinPrice() );
                        $( ".maxPrice" ).text( "$" + getMaxPrice() );
                    }
                }
            });
        })

    }

});
